import services from './../../../services/service'; // Service Class

let service = new services();

export default {
    name: 'Orders',
    data () {
        return {
          user: {},
          orders:{},
          order: {},
          img_product_url: service.imageProductsURL,
          loading:true,
          show_all:true,
          show_single:false,
          is_new:false
        }
      },
    components: {
        
      },
      
    methods:{
        setOrder(order){
            this.order = order;
            this.show_all = false;
            this.show_single = true;
        },
        viewOrders(){
            this.show_all = true;
            this.show_single =false;
            this.is_new = false; //reset if set
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            this.getOrders();
                            if(this.$route.params.ordid != null){
                                this.setSingleOrder(this.$route.params.ckid);
                            }
                        }, this);
                    }else {
                    this.$router.push('login');
                    }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                        //console.log(err)
                    }
                })
            }else {
            this.$router.push('login');
            }
        },

        getOrders(){
            service.getOrders(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.orders = response.body.data;
                    this.orders.set = true;
                    this.loading = false;
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        setSingleOrder(order_no){
            for(let order of orders){
                if(order.order_no == order_no){
                    this.setOrder(order);
                }
            }
        },
    },
    created(){
        document.title = "Orders" + " | SP";
        //clear/remove if order stored in local forage
        localforage.clear(function () {}).catch(function(err) {});
        if(this.$route.params.ordid != null){
            this.show_all = false;
            this.show_single = true;
            this.is_new = true;
        }
        this.preset();
    }
     
}


// WEBPACK FOOTER //
// ./src/pages/Orderpoint/Orders/script.js